export interface WabaUpdateRequestModel {
  wabaEmail: string;
  wabaPassword: string;
  wabaId: string | null;
  wabaGuid: string;
  wabaName: string | null;
  wabaPhone: string | null;
  wabaPhoneId: string | null;
}
